import { Routes } from "@shuttlerock/router";
import { useTranslation } from "../../i18n";
import type { RouteCrashProps } from "../RouteErrorBoundary/types";
import { ErrorPage } from "./ErrorPage";

/**
 * Generic crash screen used as the default `Crash` component for route error
 * boundaries. Apps can override it (e.g. with deploy-specific recovery).
 */
export function RouteCrashPage({ reset }: RouteCrashProps) {
  const { t } = useTranslation("errorPage");
  return (
    <ErrorPage
      title={t("crash:title")}
      body={t("crash:defaultMessage")}
      primaryButton={{
        text: t("crash:button:primary"),
        onClick: reset,
      }}
      secondaryButton={{
        text: t("crash:button:secondary"),
        route: Routes.Home,
      }}
    />
  );
}
